import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  getSelectedCase,
  getSingleParty,
  setToggle,
  setToggle_2,
  toggleState,
  toggleState_2,
} from "../../../states/slices/partyInfo.slice";
import { TableComponent } from "../../../components/table/Table";
import {
  PARTY_COLUMNS_view,
  SINGLE_CASE_COLUMNS,
} from "../../../components/table/columns";
import Typography from "../../../components/Typography";
import {
  CHEVRON_LEFT,
  FLAG,
  MINUS,
  PDF,
  PDF_ICON,
  PLUS,
  QUESTION,
  UPLOAD,
} from "../../../assets";
import { formatCurrency, getFlagStyle, getJSONheader } from "../../../utils";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import Api from "../../../config";
import { useGetPaymentsQuery } from "../../../services/apis/cases";
import { toast } from "react-hot-toast";
import PartyInformation from "../../../components/modals/Partinformation";
import FillingFee from "../../../components/modals/FillingFee";
import { selectUser } from "../../../states/slices/authReducer";
import { Autocomplete, TextField } from "@mui/material";
import Modal from "../../../components/UI/modal";
import moment from "moment";

function ProcessPayment() {
  const getCase = useAppSelector(getSelectedCase);
  // const user = useAppSelector(selectUser);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(3);
  const navigate = useNavigate();
  const [remark, setRemark] = useState<any>("");
  const [paymentID, setPaymentID] = useState<any>();
  const [remarkRequire, setRemarkRequire] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const toggleStatus = useAppSelector(toggleState);
  const toggleStatus_2 = useAppSelector(toggleState_2);
  const singlePartyInfo = useAppSelector(getSingleParty);
  const dispatch = useAppDispatch();
  const [products, setProducts] = useState<any[]>([getCase?.case_documents]);
  //   const [totalPrice, setTotalPrice] = useState<number>();
  // const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [userJudgeData, setUserJudgeData] = useState<any>(null);
  const [openDoc, setOpenDoc] = useState(false);
  const [url, setUrl] = useState<any>(null);
  const [sendToUser, setSendToUser] = useState<any>("");
  const [docTab, setDocTab] = useState<"ALL" | "CLAIMANT" | "DEFENDANT">("ALL");

  const claimantDocs = (getCase?.case_documents || []).filter((doc: any) => {
    const title = (doc?.party_title || "").toLowerCase();
    return title.includes("claimant") || title.includes("plaintiff");
  });
  const defendantDocs = (getCase?.case_documents || []).filter((doc: any) => {
    const title = (doc?.party_title || "").toLowerCase();
    return title.includes("defendant");
  });
  const displayedDocs =
    docTab === "CLAIMANT"
      ? claimantDocs
      : docTab === "DEFENDANT"
      ? defendantDocs
      : getCase?.case_documents || [];

  useEffect(() => {
    fetchDataFromBackend();
  }, [getCase?.case_documents]);

  useEffect(() => {
    if (!userJudgeData) {
      handleJudgeUsers();
    }
  }, [userJudgeData]);

  // useEffect(() => {
  // 	if (userJudgeData?.length > 0 && userMagistrateData?.length > 0) {
  // 		setMergedData(userJudgeData.concat(userMagistrateData));
  // 	}
  // }, [userJudgeData, userMagistrateData]);

  const totalPrice = getCase.case_documents?.reduce(
    (accumulator: any, product: any) => accumulator + product.price,
    0
  );

  const handleJudgeUsers = () => {
    setLoading(true);
    Api.get(`/presiding/judges`, getJSONheader()).then((res) => {
      setLoading(false);
      setUserJudgeData(res.data.data);
    });
  };

  const fetchDataFromBackend = () => {
    // Simulated data from the backend

    const updatedProducts = getCase?.case_documents.map((data: any) => ({
      case_document_id: data.id,
      file_path: data.file_path,
      title: data.title,
      price: 0,
    }));
    // Initialize price as empty string

    setProducts(updatedProducts);
  };

  const { paymentData, isLoadingCases, refetch } = useGetPaymentsQuery(null, {
    selectFromResult: ({ data, isLoading, isError }: any) => ({
      paymentData: data?.data,
      isLoadingCases: isLoading,
    }),
  });

  useEffect(() => {
    handlePaymentData(paymentData);
  }, [paymentData]);

  useEffect(() => {
    refetch();
  }, [page]);

  const handlePaymentData = (paymentData: any[]) => {
    paymentData?.map((item: any) => {
      if (item?.service?.id === getCase?.id) {
        // console.log(item, 'ddd');

        setPaymentID(item);
        return item;
      }
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    Api.post(
      `/presiding/case-folders/${getCase?.id}/assign`,
      {
        // user_id: user.id,
        user_id: sendToUser?.id,
      },
      getJSONheader()
    )
      .then((res) => {
        toast.success(`${res?.data.message}`, {
          duration: 3000,
        });
        // console.log(res.data);
        setLoading(false);

        navigate("/presiding-judge/case-folders");
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error?.response?.data?.message, {
          duration: 3000,
        });
      });
  };

  const handleChangeTo = (event: any, newValue: any) => {
    setSendToUser(newValue);
  };

  const HandleOpenDoc = () => {
    return (
      <Modal
        open={openDoc}
        close={() => {
          setOpenDoc(false);
          setUrl(null);
        }}
        maxWidth="lg"
      >
        <iframe title="PDF Viewer" src={url} className="w-full " height={900} />
      </Modal>
    );
  };

  return (
    <>
      <div className="bg-[#F8F8F9E5]/90  w-full py-2 px-8">
        <Typography textStyle="text-base">{`My Files  / ${getCase?.title}`}</Typography>
      </div>

      <div className="pt-4 px-4 lg:px-8 mb-4">
        <Typography textStyle="text-base font-medium mb-2">
          Case Folder Information
        </Typography>
        <div className="mt-2 mb-6">
          {getCase ? (
            <TableComponent
              className="rounded-none rounded-t-0"
              DATA={[getCase]}
              COLUMNS={SINGLE_CASE_COLUMNS}
              TITLE=""
              isExport={null}
              isPaginated={null}
              isSearch={null}
              size={size}
              setSize={setSize}
              setPageIndex={() => page + 1}
            />
          ) : (
            <Typography
              variant="label"
              textStyle="font-medium text-center mb-6"
            >
              No Case Folder Information
            </Typography>
          )}
        </div>
        <Typography textStyle="text-base font-medium mb-2">
          Party Information
        </Typography>
        <div className="mt-2 mb-6">
          {getCase?.parties?.length > 0 ? (
            <TableComponent
              className="rounded-none rounded-t-0"
              DATA={getCase?.parties}
              COLUMNS={PARTY_COLUMNS_view}
              TITLE=""
              isExport={null}
              isPaginated={null}
              isSearch={null}
              size={size}
              setSize={setSize}
              setPageIndex={(value: number) => page + 1}
            />
          ) : (
            <Typography
              variant="label"
              textStyle="font-medium text-center mb-6"
            >
              No Party Information
            </Typography>
          )}
        </div>
        <div className="pt-8">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
            <Typography textStyle="text-base font-medium ">
              Uploaded Documents
            </Typography>
            <div className="inline-flex p-1 bg-gray-100 rounded-lg text-xs font-medium border border-gray-200">
              <button
                type="button"
                onClick={() => setDocTab("ALL")}
                className={`px-3 py-1.5 rounded-md transition-all ${
                  docTab === "ALL"
                    ? "bg-white text-brand_indigo shadow-sm font-semibold"
                    : "text-gray-600 hover:text-black"
                }`}
              >
                All Documents ({getCase?.case_documents?.length || 0})
              </button>
              <button
                type="button"
                onClick={() => setDocTab("CLAIMANT")}
                className={`px-3 py-1.5 rounded-md transition-all ${
                  docTab === "CLAIMANT"
                    ? "bg-white text-brand_indigo shadow-sm font-semibold"
                    : "text-gray-600 hover:text-black"
                }`}
              >
                Claimant Suit ({claimantDocs.length})
              </button>
              <button
                type="button"
                onClick={() => setDocTab("DEFENDANT")}
                className={`px-3 py-1.5 rounded-md transition-all ${
                  docTab === "DEFENDANT"
                    ? "bg-white text-brand_indigo shadow-sm font-semibold"
                    : "text-gray-600 hover:text-black"
                }`}
              >
                Defendant Suit ({defendantDocs.length})
              </button>
            </div>
          </div>
          <div className="my-2 lg:flex justify-between items-center flex-wrap ">
            {displayedDocs?.length > 0 ? (
              displayedDocs.map((item: any, index: number) => (
                // <div key={index} className="w-full lg:w-[48%] ">
                //   <div className="flex justify-between items-center mb-3 border border-gray-200  p-3  rounded-lg">
                //     <div className="flex justify-start items-center ">
                //       <img src={PDF} className="h-6 w-6" />
                //       <div className="ml-4">
                //         <p className="text-left text-gray-400 text-xs ">
                //           Document Title
                //         </p>
                //         <p className=" text-black font-bold text-sm mt-1">
                //           {item?.title}
                //         </p>
                //       </div>
                //     </div>

                //     <p className="text-[#22C55E] text-lg font-medium ml-4">
                //       {`${formatCurrency({
                //         iso: "en-ng",
                //         slug: "NGN",
                //       }).format(item?.price)}`}
                //     </p>
                //   </div>
                //   <a
                //     onClick={() => {
                //       setUrl(item?.file_path);
                //       setOpenDoc(true);
                //     }}
                //     target="_blank"
                //     className="px-2 py-1 cursor-pointer bg-brand_indigo text-[#fff] text-xs  w-28  rounded-md"
                //   >
                //     View only
                //   </a>
                // </div>
                <div className="w-full max-h-[400px] overflow-y-auto py-2">
                  <div className="border-[1.1px] rounded-lg px-5 py-3 grid grid-cols-[auto_1fr_80px_64px] items-center gap-x-4 border-[#E9EFF4] w-full">
                    {/* Flag Label */}
                    <div>
                      <span
                        className={`text-[10px] font-semibold px-2 py-1 rounded-full ${getFlagStyle(
                          item?.party_title
                        )}`}
                      >
                        {item?.party_title.charAt(0).toUpperCase() +
                          item?.party_title.slice(1).toLowerCase()}
                      </span>
                    </div>

                    {/* File Info */}
                    <div className="flex items-center gap-x-4">
                      <img src={PDF_ICON} className="w-6 h-6" alt="PDF" />
                      <div className="flex flex-col">
                        <span className="text-[#292929] text-sm font-medium">
                          {item?.title}
                        </span>
                        <span className="text-[#292929] text-xs">
                          {moment(item?.created_at).format("MM/DD/YYYY")}
                        </span>
                      </div>
                    </div>

                    {/* Price */}

                    <div className="text-sm text-[#3A3A49] flex items-center justify-center h-[36px] rounded-lg bg-[#FAFAFB] border-2 border-[#E9EFF4]">
                      {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                        item?.price
                      )}
                    </div>

                    {/* View Button */}
                    <button
                      onClick={() => {
                        setUrl(item?.file_path);
                        setOpenDoc(true);
                      }}
                      className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-brand_indigo h-9 w-full"
                    >
                      View
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="py-6 w-full text-center">
                <Typography variant="label" textStyle="font-medium text-center text-gray-500">
                  {docTab === "CLAIMANT"
                    ? "No Claimant Suit Documents Uploaded"
                    : docTab === "DEFENDANT"
                    ? "No Defendant Suit Documents Uploaded"
                    : "No Uploaded Documents"}
                </Typography>
              </div>
            )}
          </div>
        </div>
        <div className="w-1/2 mt-2 mb-4">
          <label className="text-sm mb-6">Send to </label>
          {userJudgeData?.length > 0 && (
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={userJudgeData}
              value={sendToUser}
              onChange={handleChangeTo}
              getOptionLabel={(option: any) =>
                option.first_name ?? "Select a Personnel"
              } // Specify the label property to be displayed in the input field
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} label="Search for required personnel " />
              )}
              renderOption={(props, option) => (
                <>
                  <li {...props}>
                    <div>
                      <span className="text-sm">{`${option?.first_name}   ${
                        option?.last_name ?? ""
                      } `}</span>{" "}
                      {/* Render the label */}
                      <span
                        style={{
                          marginLeft: "5px",
                          fontSize: "10px",
                          color: "gray",
                        }}
                      >
                        ({option?.role}) {/* Render the year */}
                      </span>
                    </div>
                  </li>
                </>
              )}
            />
          )}
        </div>
        <div className={` justify-between lg:flex  items-end`}>
          <div className="w-full lg:w-[40%]">
            <Typography textStyle="text-[20px] font-medium mb-2">
              <>
                Remarks <sup className="text-red-600 text-xs">*</sup>
              </>
            </Typography>

            <textarea
              name="remark"
              placeholder={"Kindly add remarks"}
              className="bg-[#13BAED0D] h-40 w-full resize-none flex justify-start p-4 text-sm"
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
                setRemarkRequire("");
              }}
            />
            <small className="text-red-600">{remarkRequire}</small>
          </div>

          <div className="ml-4 w-full lg:w-[30%] mt-2 lg:mt-0">
            <Typography textStyle="text-[20px] font-medium text-center">
              Total
            </Typography>

            <p className="text-center text-green-600 bg-[#D9D9D91A] text-2xl text-semibold  p-2  min-w-44 rounded-lg">
              {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                totalPrice ? totalPrice : 0
              )}
            </p>
          </div>
        </div>
        <div className="w-full md:flex justify-between items-end mt-10">
          <div className="w-full lg:w-[45%] flex justify-between items-center flex-wrap">
            <Button
              icons={CHEVRON_LEFT}
              iconClassName="h-[0.9rem] w-3"
              title="Back"
              bgColor={"bg-brand_indigo"}
              onClick={() => navigate("/presiding-judge/case-folders")}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-32 hidden md:flex"}
            />

            <div className="w-40 md:w-44 md:hidden">
              <Button
                isLoading={loading}
                icons={FLAG}
                iconClassName="h-[0.9rem] w-3"
                bgColor={"bg-[#27AE60]"}
                title={"Assign"}
                onClick={() => handleSubmit()}
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-full"}
              />
            </div>
          </div>

          <div className="w-[30%] md:w-44 mx-auto lg:mx-0 mt-3 lg:mt-0">
            <Button
              icons={CHEVRON_LEFT}
              iconClassName="h-[0.9rem] w-3"
              title="Back"
              bgColor={"bg-brand_indigo"}
              onClick={() => navigate("/presiding-judge/case-folders")}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-32 md:hidden flex"}
            />
            <Button
              isLoading={loading}
              icons={FLAG}
              iconClassName="h-[0.9rem] w-3"
              bgColor={"bg-[#27AE60]"}
              title={"Assign"}
              onClick={() => handleSubmit()}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-full hidden md:flex"}
            />
          </div>
        </div>
        <PartyInformation
          open={toggleStatus}
          close={() => dispatch(setToggle(false))}
          data={singlePartyInfo}
        />
        <FillingFee
          open={toggleStatus_2}
          close={() => dispatch(setToggle_2(false))}
        />
        {HandleOpenDoc()} {/* Conditionally render the modal */}
      </div>
    </>
  );
}

export default ProcessPayment;
